import React from 'react';

function LoadingData(){
    return (
        <div className={"troubles"} style={{color: "black",backgroundColor:"white",textAlign: "center", fontSize: "32px"}}>
            <img alt="loading" style={{width:64+"px",height:64+"px",marginTop:25+"px",marginBottom:20+"px"}} src={"/img/loading3.gif"}/><br/><strong>Veriler yükleniyor</strong>
        </div>
    )
}


export default LoadingData;